import React from "react";
import withView from '../../../cmn/docAutomation/withView';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import SarasTrans from "../../../../library/notifications/SarasTrans";
import FormWrapper from "../../../../library/form/components/FormWrapper";
import { UiView, UiViewHeading, UiTitle, UiViewContent, UiGridColOne, UiCol } from "../../../../library/layout/Index";

const VoucherHeader2 = (props) => {
    const { formObject } = props;

    return(
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Voucher Detail' />
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "voucherDate" }} value="Voucher Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "voucherDate" }} className="uiVal uiHighlightKey" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currency" }} className="uiVal uiHighlightKey" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exRate" }} value="Exchange Rate" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "exRate" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "voucherAmt" }} value="Voucher Amount" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "voucherAmt" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxDeducted" }} value="Tax Deducted" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "taxDeducted" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amtToAdjust" }} value="Amount to Adjust" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "amtToAdjust" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargeAmount" }} value="Charge Amount" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "chargeAmount" }} />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} >
                                <span className='uiRed'>
                                    <SarasTrans value="Budget Code and Cost Center is Required if Charge Amount > 0" />
                                </span>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} value="Budget Code" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} >

                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} value="Cost Center" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} className='uiVal' />
                            </FormWrapper>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(VoucherHeader2, "voucherFooter", "") 